<app-nav-bar></app-nav-bar>

<div class="full-width-container">
  <ngx-spinner
    [fullScreen]="true"
    bdColor="rgba(0, 0, 0, 0.3)"
    color="#fff"
    name="main"
    size="medium"
    type="line-scale"
  ></ngx-spinner>

  <router-outlet></router-outlet>
</div>
